(function (window) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  function init(form) {
    const productImageContainer = form.querySelector('.consumer-rx-form__product-image');
    // If no product image container found, exit early.
    if (!productImageContainer) return;
    const productImages = productImageContainer.querySelectorAll('img');
    const productImageToggler = form.querySelector('.consumer-rx__toggle-alternate-image');

    // If no product image container is found, do nothing.
    if (!productImageContainer) return;

    if (productImageToggler) {
      // Hide toggler by default.
      productImageToggler.closest('.form-item--checkbox')
        .setAttribute('aria-hidden', true);
      // Toggle an alternate image via a checkbox.
      productImageToggler.addEventListener('click', toggleImages);
      window.componentEvents.on('swatch-list-toggle', updateClipOnVisibility);
    }

    window.componentEvents.on(`rx-form-nav-${form.id}`, updateImageAccessibility);
    window.componentEvents.on(`rx-form-reset-${form.id}`, resetAlternateImage);

    /**
     * Toggle between regular and clip-on product images according to whether the
     * clip-on checkbox is checked.
     */
    function toggleImages() {
      const altImage = productImageContainer.querySelector('img.consumer-rx__product-image-alternate');
      const mainImage = productImageContainer.querySelector('img:not(.consumer-rx__product-image-alternate)');
      // If the checkbox is checked, show alt image and hide main image.
      // Otherwise, do the opposite.
      if (productImageToggler.checked) {
        altImage.setAttribute('aria-hidden', false);
        mainImage.setAttribute('aria-hidden', true);
      } else {
        altImage.setAttribute('aria-hidden', true);
        mainImage.setAttribute('aria-hidden', false);
      }
    }

    /**
     * Show/hide product images according to navigation position.
     */
    function updateImageAccessibility() {
      if (form.dataset.rxActiveStep === form.dataset.rxTotalSteps) {
        disableImages();
      } else {
        enableImages();
      }
    }

    /**
     * Enable/show product images.
     */
    function enableImages() {
      productImageContainer.setAttribute('aria-hidden', false);
      if (productImageToggler) {
        productImageToggler.setAttribute('tabindex', 0);
      }
    }

    /**
     * Disable/hide product images.
     */
    function disableImages() {
      productImageContainer.setAttribute('aria-hidden', true);
      if (productImageToggler) {
        productImageToggler.setAttribute('tabindex', -1);
      }
    }

    /**
     * Reset the alternate image if it was toggled on
     */
    function resetAlternateImage() {
      for (let i = 0; i < productImages.length; i++) {
        const productImage = productImages[i];
        productImage.setAttribute('aria-hidden', 'false');
        if (productImage.classList.contains('consumer-rx__product-image-alternate')) {
          productImage.setAttribute('aria-hidden', 'true');
        }
      }
    }

    /**
     * Update the clip-on toggle’s visibility according to whether a clip-on
     * color has been selected.
     */
    function updateClipOnVisibility(data) {
      // If the expanded swatch list is not for clip-on lenses, do nothing.
      if (data.feature !== 'clip-on-color') return;
      // Set the toggler’s parent’s aria-hidden attribute by coercing the value
      // of the swatch list toggle’s state into a Boolean representing the
      // opposite of said value. If the toggle state is expanded, aria-hidden
      // should be false; if the toggle state is NOT expanded, aria-hidden should
      // be true.
      productImageToggler.closest('.form-item--checkbox')
        .setAttribute('aria-hidden', data.state !== 'expanded');
    }
  }
})(this);
